import angular from 'angular';

export default angular.module('directives.refresher', [])
  .directive('refresher', ($rootScope) => {
    'ngInject';

    return {
      transclude: true,
      scope: {
        watcher: '<',
        updateBlocked: '<?',
      },
      link: (scope, element, _, _2, transcludeFn) => {
        let childScope;

        $rootScope.$on('refresherUpdate', () => {
          transcludeFn((clone, newScope) => {
            childScope = newScope;
            element.append(clone);
          });
        });

        scope.firstStart = true;

        scope.$watch('watcher', () => {
          if (scope.updateBlocked && !scope.firstStart) return;
          scope.firstStart = false;

          element.empty();
          if (childScope) {
            childScope.$destroy();
            childScope = null;
          }

          transcludeFn((clone, newScope) => {
            childScope = newScope;
            element.append(clone);
          });
        }, true);
      },
    };
  })
  .name;
